import { createUseMutationHook } from './createUseMutationHook';

export const useAddChatParticipant = createUseMutationHook(
    'person_trip_join_chat',
    () => [],
);
